import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

var API = "/api";

var WishlistContext = createContext();

export function WishlistProvider({ children }) {
  var auth = useAuth();
  var [wishlistIds, setWishlistIds] = useState([]);
  var [isLoading, setIsLoading] = useState(false);

  var fetchWishlistIds = useCallback(function() {
    if (!auth.isAuthenticated) {
      setWishlistIds([]);
      return Promise.resolve([]);
    }
    setIsLoading(true);
    return axios.get(API + "/wishlist/ids", { withCredentials: true })
      .then(function(res) {
        setWishlistIds(res.data.product_ids || []);
        return res.data.product_ids || [];
      })
      .catch(function() {
        setWishlistIds([]);
        return [];
      })
      .finally(function() { setIsLoading(false); });
  }, [auth.isAuthenticated]);

  useEffect(function() {
    fetchWishlistIds();
  }, [fetchWishlistIds]);

  var addToWishlist = useCallback(function(productId) {
    return axios.post(API + "/wishlist/" + productId, {}, { withCredentials: true })
      .then(function(res) {
        setWishlistIds(function(prev) { return prev.indexOf(productId) === -1 ? [...prev, productId] : prev; });
        return res.data;
      });
  }, []);

  var removeFromWishlist = useCallback(function(productId) {
    return axios.delete(API + "/wishlist/" + productId, { withCredentials: true })
      .then(function(res) {
        setWishlistIds(function(prev) { return prev.filter(function(id) { return id !== productId; }); });
        return res.data;
      });
  }, []);

  var isInWishlist = useCallback(function(productId) {
    return wishlistIds.indexOf(productId) !== -1;
  }, [wishlistIds]);

  var value = {
    wishlistIds: wishlistIds,
    isLoading: isLoading,
    count: wishlistIds.length,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    isInWishlist: isInWishlist,
    refresh: fetchWishlistIds
  };

  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
}

export function useWishlist() {
  var context = useContext(WishlistContext);
  if (!context) throw new Error("useWishlist must be used within WishlistProvider");
  return context;
}
